/**
 * Sample figures for Analytics & Reports.
 *
 * ---------------------------------------------------------------------------
 * THIS IS PLACEHOLDER DATA. None of it is read from the server.
 *
 * The Dashboard no longer appears here: it is fully live off
 * GET /api/pharmacy/dashboard/, which returns the banner figures, every Needs
 * Attention queue with its count and value, top sellers and recent bills.
 *
 * Analytics & Reports has no equivalent endpoint yet - what it would need is
 * listed in ANALYTICS_ENDPOINTS_NEEDED at the bottom of this file. Each block
 * below is shaped the way the screen wants it, so swapping in a real call means
 * replacing the import, not reworking the component.
 * ---------------------------------------------------------------------------
 */

/** The four band figures and the period they cover. */
export const SAMPLE_ANALYTICS = {
  period: "This Month",
  salesBilled: 7332,
  purchaseOrdered: 165650,
  salesReturns: 734,
  purchaseReturns: 4991,
  billCount: 5,
  purchaseOrderCount: 5,
  returnCount: 7,
};

/** Share of sales by medicine category. */
export const SAMPLE_CATEGORY_SPLIT = [
  { label: "Antibiotics", percent: 34, color: "#3b6ef6" },
  { label: "Analgesics", percent: 26, color: "#12B76A" },
  { label: "Diabetic Care", percent: 22, color: "#EAAA5E" },
  { label: "Others", percent: 18, color: "#D0D5DD" },
];

/** How the catalogue is holding up. */
export const SAMPLE_STOCK_HEALTH = [
  { label: "Active", count: 5, color: "#12B76A" },
  { label: "Low Stock", count: 3, color: "#EAAA5E" },
  { label: "Out of Stock", count: 1, color: "#F97066" },
  { label: "Near Expiry", count: 1, color: "#EE46BC" },
];

/** The registers a pharmacy is asked for at month end. */
export const SAMPLE_REPORTS = [
  {
    key: "sales-register",
    label: "Sales Register",
    note: "Every bill raised in the period, with payment mode",
    icon: "coins",
  },
  {
    key: "purchase-register",
    label: "Purchase Register",
    note: "Goods received against each purchase order",
    icon: "ledger",
  },
  {
    key: "stock-ledger",
    label: "Stock Ledger",
    note: "Opening, in, out and closing for every medicine",
    icon: "layers",
  },
  {
    key: "expiry-report",
    label: "Expiry Report",
    note: "Batches inside the chosen expiry window",
    icon: "clock",
  },
  {
    key: "vendor-ledger",
    label: "Vendor Ledger",
    note: "What is owed to and returned against each vendor",
    icon: "storefront",
  },
  {
    key: "gst-summary",
    label: "GST Summary",
    note: "HSN-wise taxable value and tax collected",
    icon: "percent",
  },
];

/**
 * What the backend would need for the blocks above to become real. Kept here so
 * it travels with the data it explains.
 *
 *  Band totals       sales billed, purchase ordered and both return ledgers for
 *                    a given date range.
 *
 *  Sales by category share of sales value per medicine category.
 *
 *  Stock health      catalogue counts by state (active / low / out / expiring).
 *
 *  Reports           a generate endpoint per register, returning a file or a
 *                    pre-signed URL. Until then the report cards say so rather
 *                    than pretending to download.
 */
export const ANALYTICS_ENDPOINTS_NEEDED = true;
